import { createFileRoute, redirect } from '@tanstack/react-router';

/** /settings → first tab. */
export const Route = createFileRoute('/_app/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/users', replace: true });
  },
});
